import React, { useState } from 'react';
import './key-word-modal.scss';
import { UiInput } from '@ru-digital-assets/ui-component';
import Modal from 'modules/modal';
import AppCheckbox from 'modules/app-checkbox/app-checkbox';

interface IKeyWordModal {
  open: boolean;
  onClose: () => void;
  onSubmit: (keyWord?: string) => void;
}

export default function KeyWordModal({
  open,
  onClose,
  onSubmit,
}: IKeyWordModal) {
  const [keyWord, setKeyWord] = useState<string>();
  const [keyWordRepeat, setKeyWordRepeat] = useState<string>();
  const [withoutKeyWord, setWithoutKeyWord] = useState(false);

  return (
    <div className="key-word-modal">
      <Modal
        header={<b>Шифрование файла Ключа</b>}
        onClose={onClose}
        open={open}
        closeByBackground={false}
        body={
          <div>
            <p className="p mb_32">
              Для надежного хранения Ключа, а также для возможности его
              восстановления, придумайте кодовое слово
            </p>
            <UiInput
              value={keyWord || ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setKeyWord(e.target.value)
              }
              className="mb_32"
              type="password"
              label="Кодовое слово"
            />
            <UiInput
              value={keyWordRepeat || ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setKeyWordRepeat(e.target.value)
              }
              className="mb_32"
              type="password"
              label="Повторите кодовое слово"
            />
            <AppCheckbox
              checked={withoutKeyWord}
              sm
              onChangeValue={(value) => setWithoutKeyWord(value)}
              title="Не задавать кодовое слово (не рекомендуется) "
            />
          </div>
        }
        footer={{
          left: (
            <button className="button button_secondary" onClick={onClose}>
              Отмена
            </button>
          ),
          right: (
            <button
              className={`button button_primary ${
                (!keyWord || keyWord !== keyWordRepeat) && !withoutKeyWord
                  ? 'button_disabled'
                  : ''
              }`}
              onClick={() => {
                onSubmit(withoutKeyWord ? '' : keyWord);
              }}
            >
              Сохранить
            </button>
          ),
        }}
      />
    </div>
  );
}
